import { CtaBand } from '@/components/common/CtaBand';
import { PageHeader } from '@/components/common/PageHeader';
import { PageMeta } from '@/components/common/PageMeta';
import { AboutCta, AboutPage } from '@/pages/About/data';
import { PrinciplesSection } from '@/pages/About/sections/PrinciplesSection';
import { QualitySection } from '@/pages/About/sections/QualitySection';
import { RolesSection } from '@/pages/About/sections/RolesSection';
import { StorySection } from '@/pages/About/sections/StorySection';

export default function About() {
  return (
    <>
      <PageMeta title={AboutPage.title} description={AboutPage.description} />
      <PageHeader title={AboutPage.heading} description={AboutPage.description} />
      <StorySection />
      <PrinciplesSection />
      <RolesSection />
      <QualitySection />
      <CtaBand title={AboutCta.title} description={AboutCta.description} />
    </>
  );
}